//JS for front end only. Will not be included in the editor.
import { Splide } from '@splidejs/splide';

document.addEventListener('DOMContentLoaded', function() {
    init_resourcesSplideBlock();
    const filterBlocks = document.querySelectorAll('.filterable-resources-block');

    filterBlocks.forEach(block => {
        const buttons = block.querySelectorAll('.filter-btn');
        const cards   = block.querySelectorAll('.resource-card');

        buttons.forEach(btn => {
            btn.addEventListener('click', () => {
                
                // 1. Manage Active State on Buttons
                buttons.forEach(b => b.classList.remove('active'));
                btn.classList.add('active');

                // 2. Get the filter value
                const filterValue = btn.getAttribute('data-filter');

                // 3. Show/Hide Cards by toggling a CSS class
                cards.forEach(card => {
                    if (filterValue === 'all') {
                        card.classList.remove('is-hidden');
                    } else {
                        // Split the data attribute into an array of slugs
                        const cardCats = card.getAttribute('data-categories').split(' ');
                        
                        if (cardCats.includes(filterValue)) {
                            card.classList.remove('is-hidden');
                        } else {
                            card.classList.add('is-hidden');
                        }
                    }
                });
            });
        });
    });

});

    function init_resourcesSplideBlock(){
    const carousels = document.querySelectorAll('.resources-carousel');
    if (!carousels.length) return;

    carousels.forEach(carousel => {
        if (carousel.classList.contains('is-initialized')) return;

        const splide = new Splide(carousel, {
            type: 'loop',
            // Show 2 items in the resources carousel by default
            perPage: 2,
            perMove: 1,
            gap: '30px',
            pagination: false,
            autoplay: true,
            pauseOnHover: false,
            pauseOnFocus: false,
            interval: 4000,
            speed: 1200,
            breakpoints: {
                // keep 2 on large screens, drop to 1 for small devices
                1200: { perPage: 2 },
                992: { perPage: 2 },
                768: { perPage: 1 }
            }
        });

        const bar = carousel.querySelector('.splide-progress-bar');

        const updateProgress = () => {
            if (!bar) return;

            const end = Math.max(splide.length - splide.options.perPage, 1);
            const rate = splide.length <= splide.options.perPage ? 1 : Math.min(splide.index / end, 1);

            bar.style.width = String(100 * rate) + '%';
        };

        splide.on('mounted move updated resized', updateProgress);

        splide.mount();
        carousel.classList.add('is-initialized');
    });
}